import { uniqueId } from 'lodash';
import IcomoonIcon from 'components/common/Icon/IcomoonIcon';
import { RendererProps } from 'plugins/types';

import { TooltipPlacement, TruncateWithTooltip } from '../components';

import './GenericFieldRenderer.scss';

type GenericFieldRendererProps = RendererProps & {
  icon?: string;
  shouldTruncate?: boolean;
  maxLength?: number;
};

export const GenericFieldRenderer = ({
  fieldId,
  value,
  icon,
  shouldTruncate = true,
}: GenericFieldRendererProps): JSX.Element => (
  <div className="GenericFieldRenderer">
    {icon && (
      <span className="GenericFieldRenderer__Icon">
        <IcomoonIcon name={icon} size={16} />
      </span>
    )}
    <span className="GenericFieldRenderer__Value" data-term-field={fieldId} data-term-value-type="string">
      {shouldTruncate && (
        <TruncateWithTooltip
          id={uniqueId(`GenericFieldRenderer-${value}-`)}
          text={value?.toString() ?? ''}
          placement={TooltipPlacement.BOTTOM}
        />
      )}
      {!shouldTruncate && (value?.toString() ?? '')}
    </span>
  </div>
);
